import { Grid, Typography, Divider } from '@mui/material';
import ProductList from './ProductList';

const ProductCardsList = () => {
    return (
        <Grid Container>
            <Grid item lg={12} sx={{
                mt: 0, pt: 0, pb: 2, px: { lg: 1 },
            }}>
                <Grid container sx={{
                    mb: 2,
                    boxShadow: 3,
                    borderRadius: 3,
                    p: ".5rem",
                    backgroundColor: "white.main"
                }}>
                    <Grid item md={12} elevation={3} sx={{ py: 1 }}>
                        <Typography
                            variant="h3"
                            color="dark.main"
                            sx={{
                                fontSize: { md: "1.5rem", lg: "1.3rem" },
                                textTransform: "capitalize",
                                color: { md: "primary.main" },
                                pb: "6px",
                                pl: ".5rem",
                            }}
                        >
                            All Gift Cards Categories
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid
                            container
                            sx={{
                                minHeight: "100%",
                                maxHeight: "100%",
                            }}
                        >
                            <Grid item sm={12} md={12} lg={12} xl={12}>
                                <ProductList />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default ProductCardsList;